import Link from '@/shared/Link';
import { PropsWithChildren } from 'react';

export interface ILinkButton {
  id?: string;
  children: JSX.Element;
  className?: string;
  href: string;
  target?: string;
  dataTestId?: string;
  prefetch?: boolean;
  external?: boolean;
  title?: string;
  scroll?: boolean;
  onClick?: () => void;
}

export const LinkButton = ({
  id,
  children,
  className,
  href,
  target,
  dataTestId,
  external,
  prefetch,
  title,
  scroll,
  onClick,
}: PropsWithChildren<ILinkButton>) => {
  return (
    <Link
      id={id}
      scroll={scroll}
      data-testid={dataTestId}
      className={className}
      href={href}
      title={title}
      target={target}
      prefetch={prefetch}
      external={external}
      onClick={onClick}
    >
      {children}
    </Link>
  );
};

export default LinkButton;
